/**
 * Get a random(ish) 10 character string
 */
export function generateRandomId(): string {
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0].reduce(
    (acc) => acc + possible.charAt(Math.floor(Math.random() * possible.length)),
    '',
  );
}
